<script>
export default {
    name: 'IconPlay'
}
</script>
<template>
    <svg
        class="base-icon icon-play"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path fill="currentColor" d="M16 12v40l40-20z" fill-rule="evenodd" />
    </svg>
</template>
